import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_-title",
  "use": "sort_-title-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_-title\"><path d=\"m13 7 4 10H9l4-10zm2.25 8h-4.5L10 17h6l-.75-2zM13 9l-1.875 5h3.75L13 9zM2.232 12l5.334-8H2V3h7v.508L8.768 4l-5.334 8H9v1H2v-.508L2.232 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol